export enum ROUTES {
  APPROVALS = '/approvals',
  DETAILED_PLAN = '/detailed-plan',
  DIVISION = '/division',
  DRAFTS = '/drafts',
  EXPORTS = '/exports',
  FAVORITES = '/favorites',
  FAVORITES_SHELLS = '/favorites/shells',
  FAVORITES_SINGLE_FAMILY = '/favorites/single-family',
  FAVORITES_UNITS = '/favorites/units',
  HOME = '/',
  PENDING_PLANS = '/pending-plans',
  PLANS = '/all-plans',
  REGIONAL_APPROVALS = '/regional-approvals',
  SHARED_WITH_ME = '/shared-with-me',
  SHELL_PLANS = '/shell-plans',
  UNIT_PLANS = '/unit-plans',
}
